module.exports = __webpack_public_path__ + "static/media/active-heart.9c1fc759.svg";